<template>
    <div id="contents" class="contents plan-your-visit">
        <JsonLd :json="jsonld" />
        <div class="breadcrumb">
            <ul>
                <li>
                    <router-link :to="{name: 'Index'}">TOP</router-link>
                </li>
                <li>Japan Heritage Videos</li>
            </ul>
        </div>

        <h1 class="ttl">Japan Heritage Videos</h1>

        <div class="grayBox">
            <div class="inner">

                <div class="article">
                    <ul>
                        <li v-on:click="openStreaksPlayer('masamune')">
                            <div class="img">
                                <figure><img
                                    src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/jh/jh_t_019_001_001_jnto.jpg"
                                    alt=""></figure>
                                <p class="btn-play"><img
                                    src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/assets/icon-play.svg"
                                    alt=""></p>
                            </div>
                            <div class="txt"><p>Sendai – Home of the Sophisticated Samurai</p></div>
                        </li>
                        <li v-on:click="openStreaksPlayer('tochigi')">
                            <div class="img">
                                <figure><img
                                    src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/jh/jh_t_057_001_001_jnto.jpg"
                                    alt=""></figure>
                                <p class="btn-play"><img
                                    src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/assets/icon-play.svg"
                                    alt=""></p>
                            </div>
                            <div class="txt"><p>A Quarry Turned Underground Labyrinth</p></div>
                        </li>
                        <li v-on:click="openStreaksPlayer('gyoda')">
                            <div class="img">
                                <figure><img
                                    src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/jh/jh_t_041_001_001_jnto.jpg"
                                    alt=""></figure>
                                <p class="btn-play"><img
                                    src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/assets/icon-play.svg"
                                    alt=""></p>
                            </div>
                            <div class="txt"><p>Gyoda – The City of Japanese Tabi Socks</p></div>
                        </li>
                        <li v-on:click="openStreaksPlayer('kamakura')">
                            <div class="img">
                                <figure><img
                                    src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/jh/jh_t_025_001_001_jnto.jpg"
                                    alt=""></figure>
                                <p class="btn-play"><img
                                    src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/assets/icon-play.svg"
                                    alt=""></p>
                            </div>
                            <div class="txt"><p>Kamakura - A Historical and Cultural Mosaic</p></div>
                        </li>
                        <li v-on:click="openStreaksPlayer('tsuwano')">
                            <div class="img">
                                <figure><img
                                    src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/jh/jh_t_013_001_001_jnto.jpg"
                                    alt=""></figure>
                                <p class="btn-play"><img
                                    src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/assets/icon-play.svg"
                                    alt=""></p>
                            </div>
                            <div class="txt"><p>The Ancient Guidebook of Tsuwano</p></div>
                        </li>
                        <li v-on:click="openStreaksPlayer('kyouiku')">
                            <div class="img">
                                <figure><img
                                    src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/jh/Jh_s_001_001_001_jnto.jpg"
                                    alt=""></figure>
                                <p class="btn-play"><img
                                    src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/assets/icon-play.svg"
                                    alt=""></p>
                            </div>
                            <div class="txt"><p>Education in Early Modern Japan</p></div>
                        </li>
                        <li v-on:click="openStreaksPlayer('nobunaga')">
                            <div class="img">
                                <figure><img
                                    src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/jh/Jh_s_006_001_001_jnto.jpg"
                                    alt=""></figure>
                                <p class="btn-play"><img
                                    src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/assets/icon-play.svg"
                                    alt=""></p>
                            </div>
                            <div class="txt"><p>A Ruthless Warlord’s Spirit of Hospitality</p></div>
                        </li>
                        <li v-on:click="openStreaksPlayer('nihoncha')">
                            <div class="img">
                                <figure><img
                                    src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/jh/Jh_s_009_001_001_jnto.jpg"
                                    alt=""></figure>
                                <p class="btn-play"><img
                                    src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/assets/icon-play.svg"
                                    alt=""></p>
                            </div>
                            <div class="txt"><p>Japanese Tea: Eight Centuries of Tradition</p></div>
                        </li>
                        <li v-on:click="openStreaksPlayer('henro')">
                            <div class="img">
                                <figure><img
                                    src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/jh/Jh_s_015_001_001_jnto.jpg"
                                    alt=""></figure>
                                <p class="btn-play"><img
                                    src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/assets/icon-play.svg"
                                    alt=""></p>
                            </div>
                            <div class="txt"><p><i>Henro</i> – A Spiritual Journey through Shikoku</p></div>
                        </li>
                        <li class="blank"></li>
                        <li class="blank"></li>
                        <li class="blank"></li>
                    </ul>
                </div>

            </div>
        </div>
        <streaks-player ref="streaks"></streaks-player>
    </div>
</template>

<script>
import StreaksPlayer from "@/components/StreaksPlayer/StreaksPlayer";
import ApiRouter from "../../components/Systems/ApiRouter";
import JsonLd from "@/components/JsonLd/JsonLd.vue";

export default {
    name: "Movies",
    components: {JsonLd, StreaksPlayer},
    mixins: [ApiRouter],
    data: function () {
        return {
            articles: [],
            jsonld:{
                "@context": "https://schema.org",
                "@graph": [
                    {
                        "@type": "Article",
                        "mainEntityOfPage": window.location.href,
                        "headline": 'Japan Heritage Videos',
                        "description": "Japan Heritage ties together historical sites, shrines, temples, traditional arts, castles, armor," +
                            "and other cultural assets. Find photos, videos, tourist information, and more.",
                        "image": [
                            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAABgCAYAAAC0TppOAAAABHNCSVQICAgIfAhkiAAAAd5JREFUeF7d3DtOAzEUBVB7SeyCFRBRAQWp0dDQkY6K9NNS8VkAu2NgEinRkPn48z735laWKx+9xnqyX/xqm4efGC6u7re3MYYuECZ+tM0mxvjche5ttd7eEBpC7A/92T6+/K2eWCE7BDvkgGCGDBCskBMEI2QUwQaZRDBBZhEskEUEAyQJgQ5JRiBDshCokGwEIqQIgQYpRiBBqhAokGoEAkQE4Q0RQ3hCRBFeEHGEB0QFYQ1RQ1hCVBFWEHWEBcQEoQ0xQ2hCTBFaEHOEBsQFIQ1xQ0hCXBFSEHeEBAQCUQuBQdRAoBBDSHhfrV+v+72lwCFKIJCIXAgsIgcCjUiFwCNSIBSIJQgNYg5ChZiC0CHGIJSIPaT5DjFehtDdUSKOr4L2VxM6xH9AXxUqxBiACjEFoEHMASgQSwB4RAoAGpEKgEXkACARuQA4RAkAClEKgEHUACAQtQB3hATAFSEFcENIAlwQ0gBzhAbAFKEFMENoAkwQ2gB1hAVAFWH52Uql22EJUKmENUAc4QEQRXgBxBCeABGEN6AagQCoQqAAihFIgCIEGiAbgQjIQqACkhHIgCQEOmARwQCYRbAAJhFMgFEEG+AEwQgYIFgBBwQzYIc4i1k2ZzFVqC8He34BnstzlSi4Q8IAAAAASUVORK5CYII="
                        ],
                        "datePublished": "2020/04/14",
                        "dateModified": "2024/11/14",
                        "author": [{
                            "@type": "Organization",
                            "name": "Japan National Tourism Organization",
                            "url": "https://www.japan.travel/japan-heritage/"
                        }]
                    },
                    {
                        "@type": "BreadcrumbList",
                        "itemListElement":  [{
                            "@type": "ListItem",
                            "position": 1,
                            "name": "TOP",
                            "item": "https://www.japan.travel/japan-heritage/"
                        },{
                            "@type": "ListItem",
                            "position": 2,
                            "name": "Japan Heritage Videos",
                            "item": "https://www.japan.travel/japan-heritage/movies"
                        }]
                    }
                ]
            }
        }
    },
    created: function () {
        this.loadData();
        document.title = 'Movies | Japan Heritage Official Site'
    },
    methods: {
        loadData: function () {
            window.axios.get(this.routes.articles)
                .then((response) => {
                    this.articles = response.data.data;
                });
        },
        articleCardHasClicked: function (id, hash) {
            this.$router.push({name: 'Popular', params: {id: id, page: 'travelInfo'}, hash: hash});
        },
        openStreaksPlayer: function (id) {
            this.$refs.streaks.open(id);
        }
    }
}
</script>

<style src="./Movies.scss" lang="scss" scoped/>
